module.exports = __webpack_public_path__ + "static/media/GB.f7fda318.svg";